var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVerifyInactive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 21,
    r: 19,
    fill: "#B6BDC1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_5733)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4 14.3333H12.6C11.7176 14.3333 11 15.0808 11 15.9999V25.9999C11 26.9191 11.7176 27.6666 12.6 27.6666H25.4C26.2824 27.6666 27 26.9191 27 25.9999V15.9999C27 15.0808 26.2824 14.3333 25.4 14.3333ZM16.372 17.6666C17.2928 17.6666 17.972 18.3741 17.972 19.3333C17.972 20.2924 17.2928 20.9999 16.372 20.9999C15.4512 20.9999 14.772 20.2924 14.772 19.3333C14.772 18.3741 15.4504 17.6666 16.372 17.6666ZM19.344 24.3333H13.4V23.9458C13.4 22.8016 14.7408 21.6249 16.372 21.6249C18.0032 21.6249 19.344 22.8016 19.344 23.9458V24.3333ZM24.6 23.4999H21.4V21.8333H24.6V23.4999ZM24.6 20.1666H20.6V18.4999H24.6V20.1666Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_5733"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(11 13)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVerifyInactive);
export default ForwardRef;